import trim from 'lodash/trim';
import cmp from '../../lib/cmp';
import on from '../../lib/dom/on';
import { setHTML, getValueString } from '../../lib/dom/inner';
import { removeClass, hasClass, addClass } from '../../lib/dom/className';
import { SUBSCRIPTION_FORM_CLOSE, SUBSCRIPTION_FORM_OPEN } from '../../config/events';
import trackSubscribe from '../../lib/track-event/subscribe';
import template from './sm-app-subscribe-v1.template.js';
import './sm-app-subscribe-v1.less';



const ELEMENT_CLASS = 'sm-app-subscribe-v1';
const HTML_SHOW_CLASS = 'html-sm-app-subscribe-v1--showed';
const SHOW_CLASS = 'sm-app-subscribe-v1--showed';
const ERROR_MESSAGE_CLASS = 'sm-app-subscribe-v1__message--error';
const MESSAGE_HIDDEN_CLASS = 'sm-app-subscribe-v1__message--hidden';
const BODY_CLASS = 'sm-app-subscribe-v1__body';
const BODY_HIDDEN_CLASS = 'sm-app-subscribe-v1__body--hidden';
const INPUT_CLASS = 'sm-app-subscribe-v1__input';
const MESSAGE_CLASS = 'sm-app-subscribe-v1__message';
const FORM_CLASS = 'sm-app-subscribe-v1__form';

export default cmp(null, template, (element, data, component) => {
  const messageNode = element.getElementsByClassName(MESSAGE_CLASS);
  const inputNode = element.getElementsByClassName(INPUT_CLASS);
  const formNode = element.getElementsByClassName(FORM_CLASS);

  const cleanups = [];
  let success = false;

  if (inputNode) {
    cleanups.push(on(formNode, 'submit', (ev) => {
      ev.preventDefault();

      if (success) {
        return;
      }

      const email = trim(getValueString(inputNode));

      if (email && /\S+@\S+\.\S+/.test(email)) {
        success = true;

        trackSubscribe(email);

        setHTML(messageNode, __('sm@_thank_you_we_will_notify_you'));
        removeClass(messageNode, ERROR_MESSAGE_CLASS);
        removeClass(messageNode, MESSAGE_HIDDEN_CLASS);
        addClass(element.getElementsByClassName(BODY_CLASS), BODY_HIDDEN_CLASS);
      } else {
        setHTML(messageNode, __('sm@_please_enter_a_valid_email'));
        addClass(messageNode, ERROR_MESSAGE_CLASS);
        removeClass(messageNode, MESSAGE_HIDDEN_CLASS);
      }
    }));
  }

  cleanups.push(on(element, 'click', (ev) => {
    if (!hasClass(ev.target, ELEMENT_CLASS)) {
      return;
    }

    component.$emit(SUBSCRIPTION_FORM_CLOSE);
  }));

  component.$on(SUBSCRIPTION_FORM_OPEN, () => {
    if (!success) {
      setHTML(messageNode, '');
      removeClass(messageNode, ERROR_MESSAGE_CLASS);
      addClass(messageNode, MESSAGE_HIDDEN_CLASS);
    }
    addClass(element, SHOW_CLASS);
    addClass(document.documentElement, HTML_SHOW_CLASS);
  });

  component.$on(SUBSCRIPTION_FORM_CLOSE, () => {
    removeClass(element, SHOW_CLASS);
    removeClass(document.documentElement, HTML_SHOW_CLASS);
  });

  return cleanups;
});



// WEBPACK FOOTER //
// ./src/components/sm-app-subscribe-v1/sm-app-subscribe-v1.js